import React from 'react';
import Questionnaire from './components/Questionnaire';

function App() {
  return (
    <div className="App">
      <Questionnaire />
    </div>
  );
}

export default App;
